import { getTrans } from 'modules/i18n';
import { ErrorScreen } from '../parts/ErrorScreen';

export const NotFoundErrorScreen = ({
  title,
  description1,
  description2
}: {
  title?: string;
  description1?: string;
  description2?: string;
}) => {
  return (
    <ErrorScreen
      title={title ?? getTrans('crashScreen.title1')}
      description1={description1 ?? getTrans('crashScreen.body1')}
      description2={description2 ?? getTrans('crashScreen.body2')}
    />
  );
};
